module.exports = __webpack_public_path__ + "img/serviceEntitlements.7e42a2a7.svg";